import React from "react";
import Timer from '../Timer';
import MenuUtils from '../../common';
import styles from './ExpoTile.module.css';

const ExpoTile = (props) => {
  const { info } = props;

  const toTitleCase = (text: string = '') => {
    text = text
      .toLowerCase()
      .split(' ')
      .map(s => s.charAt(0).toUpperCase() + s.substring(1))
      .join(' ');
    return text;
  };

  const renderModifiersRecursively = im => {
    return MenuUtils.renderModifiersRecursively(
      im,
      0,
      (i, index) => modifierRenderer(i, index),
      i => itemRenderer(i),
      true,
    );
  }

  const modifierRenderer = (menuItem, index) => (
    <div key={`modifier-${menuItem.id}`} className={styles.itemWrapper}>
      <span className={styles.modName} style={{ paddingLeft: `${index * 7 * 0.65}vh` }}>
        {toTitleCase(menuItem.modifierName || menuItem.menuItemName)}
      </span>
    </div>
  );

  const itemRenderer = menuItem => {
    return (
      <div key={`item-${menuItem.id}`} className={styles.itemWrapper}>
        <div className={styles.checkboxWrapper}>
          <input type="checkbox" className={styles.itemCheckBox} />
          <span className={styles.itemName}>{toTitleCase(menuItem.menuItemName || menuItem.name)}</span>
        </div>
        <Timer info={menuItem.sentAt} textStyle={styles.itemTimer} />
      </div>
    )
  };

  return (
    <div className={styles.tileWrapper}>
      <div className={styles.tileHeader}>
        <div className={styles.stationId}>{info.stationId}</div>
        <div className={styles.headerText}>{info.orderType.toUpperCase()}</div>
        <Timer info={info.orderDate} />
      </div>
      <div className={styles.tileContent}>
        {info.items && info.items.map((item) => {
          return renderModifiersRecursively(item);
        })}
      </div>
      <div className={styles.tileFooter}>
        <div className={styles.footerText}>{info.serverName}</div>
        <div className={styles.footerText}>{`${info.items.length} ITEMS`}</div>
        <div className={styles.footerText}>{`# ${info.id}`}</div>
      </div>
    </div>
  );
}

export default ExpoTile;